import CalendarViewDayRoundedIcon from '@mui/icons-material/CalendarViewDayRounded'
import CalendarViewWeekRoundedIcon from '@mui/icons-material/CalendarViewWeekRounded'
import type { ChecklistType } from '../../types/recurringChecklist'
import { useNls } from '../../nls/nlsProvider'
import { getChecklistCadenceLabel } from './ChecklistNls'
import { StatusChip } from '../Common'

type Props = {
  type?: ChecklistType | null
  size?: 'sm' | 'md'
}

/**
 * Passive label chip for a checklist's type. Shown in board views, manage,
 * calendar — anywhere a checklist appears outside the Checklists panel.
 * Type-swap happens only in the checklist detail popup, not here.
 */
export const ChecklistTypeChip = ({ type, size = 'sm' }: Props) => {
  const { t } = useNls()
  const resolved: ChecklistType = type ?? 'INDIVIDUAL'
  if (resolved === 'INDIVIDUAL') return null // Individual is the default; no visual noise.
  const label = getChecklistCadenceLabel(t, resolved)
  const lowerLabel = label.toLocaleLowerCase()
  const icon = resolved === 'DAILY'
    ? <CalendarViewDayRoundedIcon fontSize="inherit" />
    : <CalendarViewWeekRoundedIcon fontSize="inherit" />
  return (
    <span
      aria-label={t('NLSChecklistAriaRecurringChecklist', { cadence: lowerLabel })}
      title={t('NLSChecklistAriaRecurringChecklist', { cadence: lowerLabel })}
    >
      <StatusChip size={size} tone="info" icon={icon}>
        {label}
      </StatusChip>
    </span>
  )
}
